import React, { createContext, useContext, useState } from "react";
import {sitesListDropdownState}  from './appState';

export const SitesListDropDownContext = createContext();
export const useSitesListDropDownContext = () => useContext(SitesListDropDownContext);

export const SitesListDropDownContextProvider = (props) => {
    const [appState, setAppState] = useState(sitesListDropdownState);

    const setSitesListDropDownData = (sitesListDropDownData = []) => {
        setAppState({
            ...appState,
            sitesListDropDownData: sitesListDropDownData
        })
    }


    return (
        <SitesListDropDownContext.Provider value={{
            appState, setAppState,setSitesListDropDownData
        }} >
            {props.children}
        </SitesListDropDownContext.Provider>
    );

}
